export const settingsHeartRunnerState = {
    isLoading: false, 
    isLoadingSetting: false,
    isLoadingSyncUser: false,
    isLoadingAbortMission : false,
    isLoadingSyncLocation : false,
    errorNumber: 0,
    errorMessage: '',
    messageLabel: '',
    statusCode:'',
    isLoadingSyncUserTime : false,
    autoSyncUserTime : '',
}